// Todo: Change the wair size name
// https://www.wrike.com/open.htm?id=1240487092

var customTimer;
var customInterval;
var customCount = 0;
var oldSize = '';

var pattern = /(\d{2}|\d{3})[SRT]|(S|M|L|XL|2XL|3XL|4XL)[SRT]/g;
document.addEventListener("DOMContentLoaded", function () {
  // customTimer = setTimeout(function () {
  //   customPDP();
  // }, 1000);
  initBundleLabel();
});

var customPDP = function () {
  clearTimeout(customTimer);
  // todo: will remove after testing

  updateLengthName();
  customTimer = setTimeout(function () {
    customPDP();
  }, 1000);
};

function checkIfHasSelectLength() {
  return document.querySelector('[data-length-type]');
}

function updateLengthName() {
  var wairFitAdvisorButtons = document.querySelectorAll("#wair-fit-advisor");
  if (wairFitAdvisorButtons.length) {
    wairFitAdvisorButtons.forEach((wairFitAdvisor) => {
      var size = wairFitAdvisor.querySelector("b");
      if (size && size.innerHTML !== oldSize) {
        var sizeInnerHTML = size.innerHTML;
        var matches = sizeInnerHTML.match(pattern);
        if(matches) {
          var _matches = [...matches];
          var lengthName = matches[0][matches[0].length - 1];
          lengthName = lengthName.replace('S', ' Short').replace('R', ' Regular').replace('T', ' Tall');
          //todo: remove matches last character
          matches = matches[0].slice(0, -1);
          if(checkIfHasSelectLength()) {
            matches = lengthName + " " + matches;
          }
          var updatedSizeInnerHTML = sizeInnerHTML.replace(_matches[0], matches);
          size.innerHTML = updatedSizeInnerHTML;
          oldSize = updatedSizeInnerHTML;
        }
        showElement(wairFitAdvisor)
      } else {
        console.log("size element not found");
        
      }
      if(checkNoSize(wairFitAdvisor)) {
        showElement(wairFitAdvisor)
      }
    });    
  } else {
    console.log("Continiously Do Custom PDP");
  }
}

function showElement(element) {
  element.classList.add('show');
}

function checkNoSize(element) {
  return element.innerHTML.includes('No size available') || element.innerHTML.includes('Take Size Quiz');
}

// Todo: Add Product's bundle label
//https://www.wrike.com/open.htm?id=1246296889
function initBundleLabel() {
  // get current product json
  var productJSON = getProductJSON();
  var bundleLables = getBundleLabels(productJSON);

  if(bundleLables.length) {
    var bundleLabelContainer = document.querySelector('.exclusive_product-parent');
    var bundleLabelHTML = bundleLables.reduce((prev, label) => {
      var labelHTML = `<span class="product-grid-item__badge product-single__free-shipping">${label}</span>`;
      return prev + labelHTML;
    }, '')
    console.log("bundleLabelHTML", bundleLabelHTML)
    bundleLabelContainer.innerHTML = bundleLabelContainer.innerHTML + bundleLabelHTML;
  }
}

function getProductJSON() {
  var productJSON = document.querySelector('[data-product-json]');
  if(productJSON) {
    return JSON.parse(productJSON.innerHTML);
  }
  return null;
}

function getBundleLabels(productJSON = {}) {
  return theme.campaigns.map(campaign => {
    var {selector: { tags }} = campaign;
    var { tags: productTags } = productJSON;
    var label = '';

    tags.forEach(tag => {
      if(productTags.includes(tag)) {
        label = campaign.requirement._message
      }
    })
    return label;
  }).filter(label => !!label)
}